"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRestoredColorFromPalette = void 0;
var plasma_colors_1 = require("@salutejs/plasma-colors");
var functions_1 = require("../functions");
var paletteMap = {
    general: plasma_colors_1.general,
    additional: plasma_colors_1.additional,
};
// TODO: удалить alphaSign после того, как избавимся от старого формата тем
var getRestoredColorFromPalette = function (value, alphaSign) {
    var _a, _b;
    if (alphaSign === void 0) { alphaSign = 0; }
    if (typeof value === 'string' && value.startsWith('[') && value.endsWith(']')) {
        var _c = (0, functions_1.extractColors)(value), color = _c[1], opacity = _c[2];
        var _d = color.split('.'), palette = _d[0], shade = _d[1], saturation = _d[2];
        var resultColor = (_b = (_a = paletteMap[palette]) === null || _a === void 0 ? void 0 : _a[shade]) === null || _b === void 0 ? void 0 : _b[saturation];
        var format = 'hexa';
        var isRaw = true;
        return opacity ? (0, functions_1.alphenColor)(resultColor, Number(opacity) + alphaSign, format, isRaw) : resultColor;
    }
    return value;
};
exports.getRestoredColorFromPalette = getRestoredColorFromPalette;
//# sourceMappingURL=getRestoredColorFromPalette.js.map